import {
  Menu as MuiMenu,
  type MenuListProps as MuiMenuListProps,
  type MenuProps as MuiMenuProps,
} from '@mui/material';

import type { ForbiddenSlotStyles, WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type ListLabelProps = Pick<MuiMenuListProps, 'aria-labelledby' | 'aria-label'> & ForbiddenSlotStyles;

type Props = WithoutStyleOverrides<Omit<MuiMenuProps, 'slots' | 'slotProps' | 'elevation' | 'PopoverClasses'>> & {
  slotProps?: {
    list?: ListLabelProps;
    root?: never;
    paper?: never;
    transition?: never;
    backdrop?: never;
  };
};

export function Menu(props: Props) {
  return <MuiMenu {...props} />;
}

export type { Props as MenuProps };
